import { produce } from 'immer'
import useLandingConstructorStore from 'pages/landing/landingConstructor/zustand/store'
import existenceBlocksManager from 'pages/landing/landingConstructor/sections/existenceSection/ExistenceBlocksManager/existenceBlocksManager'

/**
 * Переключает тему блока с описанием пользователя, которому подойдёт курс
 * @param blockId — id блока, которому нужно переключить тему с белой на цветную
 */
export function useGetToggleTheme(blockId: number) {
	const [landing, updateStore] = useLandingConstructorStore((s) => [
		s.landing,
		s.updateStore,
	])

	return function () {
		if (!landing) return

		const blockIdx = existenceBlocksManager.getBlockIdx(
			landing.sections.existence.blocks,
			blockId
		)

		const updatedLanding = produce(landing, (draft) => {
			draft.sections.existence.blocks[blockIdx].colorTheme =
				draft.sections.existence.blocks[blockIdx].colorTheme == 'green'
					? 'red'
					: 'green'
		})

		updateStore({ landing: updatedLanding })
	}
}
